module.exports = __webpack_public_path__ + "img/5.63f6fcfb.png";